import * as React from "react";
const SvgIcnTime = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
        <path fill="currentColor" d="M10.5 5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 .5.5h3.5a.5.5 0 0 0 0-1h-3V5.5Z" />
        <path
            fillRule="evenodd"
            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
            clipRule="evenodd"
            fill="currentColor"
        />
    </svg>
);

export default SvgIcnTime;
